import { useTranslation } from 'react-i18next';
import { TranslationRecord } from './TranslationRecord';

type UseTypedTranslate = () => {
  t: (key: keyof TranslationRecord) => string;
};

export const useTypedTranslate: UseTypedTranslate = () => {
  const { t } = useTranslation();

  return {
    t: (key: keyof TranslationRecord) => t(key),
  };
};
